import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <span className="footer-logo mono">PuzzleForge</span>
          <span className="footer-tagline mono">AI-powered daily puzzles</span>
        </div>

        <nav className="footer-links">
          <Link to="/pricing" className="mono">Pricing</Link>
          <Link to="/terms" className="mono">Terms</Link>
          <Link to="/privacy" className="mono">Privacy</Link>
          <Link to="/refund" className="mono">Refunds</Link>
          <a href="mailto:support@puzzleforge.io" className="mono">Support</a>
        </nav>

        <p className="footer-copy mono">© 2026 PuzzleForge. All rights reserved.</p>
      </div>
    </footer>
  );
}
